import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
  apiKey: "AIzaSyA55yYJSAmrPfklcV3FtlcibXhcqztCLME",
  authDomain: "maxtocoin-37b70.firebaseapp.com",
  projectId: "maxtocoin-37b70",
  storageBucket: "maxtocoin-37b70.firebasestorage.app",
  messagingSenderId: "466067274626",
  appId: "1:466067274626:web:35d15a951c0e078b956d9b"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
